export default __webpack_public_path__ + "static/media/DashboardIcon.99fbfd52.svg";